module.exports = __webpack_public_path__ + "static/img/pillar-middle_256.3dabf31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pillar-middle_256.png
// module id = NcQG
// module chunks = 0